// SPDX-License-Identifier: AGPL-3.0-or-later

import RuntimeConfig from '@app/features/app/state/RuntimeConfig';
import type {RuntimeConfigSnapshot} from '@app/features/app/state/RuntimeConfigSnapshot';

export function privyAppId(snapshot: RuntimeConfigSnapshot | null = RuntimeConfig.getSnapshotOrNull()): string | null {
	return snapshot?.privy?.enabled === true && snapshot.privy.app_id ? snapshot.privy.app_id : null;
}

// A stable bridge for non-React logout callers. It never holds key material.
let actions: {logout: () => Promise<void>} | null = null;
export function installPrivyActions(next: NonNullable<typeof actions>): () => void {
	actions = next;
	return () => {
		if (actions === next) actions = null;
	};
}
export async function logoutPrivy(): Promise<void> {
	if (actions) await actions.logout();
}
